import { server, domains, locales } from "../../../config/index";
import Link from "next/link";
import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import Meta from "../../../components/Meta";
import Menu from "../../../components/Menu";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import HumoqImage from "../../../components/HumoqImage";
import HumoqImage2 from "../../../components/HumoqImage2";
import RecentStorage from "../../../components/RecentStorage";

const gameIconsGifs = [
  "basket-random",
  "basketball-stars",
  "bitlife-life-simulator",
  "bob-the-robber",
  "boxing-random",
  "fire-and-water-birds",
  "fireboy-and-watergirl-1-forest-temple",
  "fireboy-and-watergirl-2-light-temple",
  "fireboy-and-watergirl-3-ice-temple",
  "fireboy-and-watergirl-5-elements",
  "fireboy-watergirl-6-fairy-tales",
  "hungry-shark-arena",
  "kogama-ghost-house",
  "paperio-2",
  "snow-rider-3d",
  "squid-challenge",
];

export default function Tag({ games, tag, categories }) {
  const router = useRouter();
  const locale = router.defaultLocale;
  const { t } = useTranslation("common");

  const [recent, setRecent] = useState([]);
  const [size, setSize] = useState(0);
  const [hoveredGame, setHoveredGame] = useState("");
  const onMouseEnter = (slug) => {
    setHoveredGame(slug);
  };
  const onMouseLeave = (slug) => {
    setHoveredGame(slug);
  };

  const rs = new RecentStorage();

  const isHovered = (slug) => {
    if (
      hoveredGame != "" &&
      hoveredGame == slug &&
      gameIconsGifs.indexOf(slug) != -1
    )
      return true;
    else return false;
  };
  useEffect(() => {
    function updateSize() {
      setSize(
        window.innerHeight -
          document.querySelector(".humoqFixedMenu").clientHeight -
          document.querySelector(".mainFooter").clientHeight -
          85
      );
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  useEffect(() => {
    setRecent(rs.list());
  }, []);

  const recentIds = recent.map((r) => r.id);
  const gameList = recent.concat(
    games.filter((x) => recentIds.indexOf(x.id) == -1)
  );
  return (
    <>
      <Meta
        title={t("TagpageTitle", { tagUppercase: tag.toUpperCase(), tag: tag })}
        description={t("TagpageDescription", {
          tagGames: games?.slice(0, 4).map((gm, i) => " " + gm.title),
          tag: tag,
        })}
        image={`https://${t("DOMAIN")}/facebook.jpg`}
        url={router.asPath}
      />
      <Header cat={categories} />
      <div className="humoqRow">
        <div className="containerNew" style={{ minHeight: size }}>
          <div className="humoqBreadCrumb">
            <ol>
              <li className="slash">
                <a href="/">Home</a>
              </li>
              <li>{tag}</li>
            </ol>
          </div>
          <div>
            <h1 className="humoqTitle">
              {tag} {t("MOST_POPULAR")}
            </h1>
            <div
              className={
                recent != null
                  ? "humoqWrapper"
                  : "humoqWrapper colOneItemEffect"
              }
            >
              <div className="mobileHomeMenu">
                <Menu catUrl={categories} />
              </div>
              {gameList?.map((game, i) => (
                <a
                  alt={game.title}
                  key={i}
                  href={`/${game?.slug}`}
                  className={
                    "humoqColCat hqCatCol-" +
                    i +
                    (i < 3 ? " hqCol col-" + i : "")
                  }
                  onMouseEnter={() => {
                    onMouseEnter(game?.slug);
                  }}
                  onMouseLeave={() => {
                    onMouseLeave(game?.slug);
                  }}
                >
                  <HumoqImage
                    alt={game?.title}
                    width={i <= 3 ? 512 : 140}
                    type="tag"
                    isHovered={isHovered(game?.slug) && i < 3}
                    height={i <= 3 ? 512 : 140}
                    i={i}
                    src={game?.slug}
                  />
                  <div className="humoqText">{game?.title}</div>
                </a>
              ))}
            </div>
            <div className="catScope">
              {categories?.map((cat, i) => (
                <a
                  alt={cat?.name + " " + t("MOST_POPULAR")}
                  key={i}
                  href={`/c/${cat.slug}`}
                  className="catBox"
                >
                  <div className="catImg">
                    {[
                      "exclusive", // en
                      "exklusiv", // de
                      "exclusif", // fr
                      "esclusivo", // it
                      "exkluzivní", // cs
                      "ekskluzywny", // pl
                      "exclusief", // nl
                    ].includes(cat.slug.toLowerCase()) ? (
                      <img
                        className="static-icon"
                        alt={cat.slug}
                        src="/category-icons/exclusive.png"
                        height={30}
                        width={30}
                      />
                    ) : [
                        "bambino", // it
                        "dite", // cs
                      ].includes(cat.slug.toLowerCase()) ? (
                      <img
                        className="static-icon"
                        alt={cat.slug}
                        src="/category-icons/baby.png"
                        height={30}
                        width={30}
                      />
                    ) : (
                      <HumoqImage2
                        alt={`${cat.name}`}
                        src={`/category-icons/${locale}/${cat.slug}.png`}
                        height={30}
                        width={30}
                      />
                    )}
                  </div>
                  <div className="catText">{cat.name}</div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export const getServerSideProps = async (context) => {
  const domainId = locales[context.defaultLocale];
  const id = decodeURIComponent(context?.params?.id).replace("#", "");
  const url = `${server}/api/v1/games/tag/${encodeURIComponent(
    id
  )}?domain_id=${domainId}`;
  const category_url = `${server}/api/v1/categories?domain_id=${domainId}`;
  const res = await fetch(url);
  const res_category = await fetch(category_url);
  const resultJSON = await res.json();
  const resultCatJSON = await res_category.json();
  const games = resultJSON.data;
  const categories = resultCatJSON.data;
  const tag = context.params.id;
  if (games.length === 0) {
    return {
      notFound: true,
    };
  }
  return {
    props: {
      games,
      tag: tag,
      categories,
      ...(await serverSideTranslations(context.defaultLocale, ["common"])),
    },
  };
};
